/**
 *
 * DesktopMenu
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 26-Oct-2022
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { AppBar, Toolbar, ListItemText, Grid, Button, Typography } from '@mui/material';
import PortalModal from 'Components/PortalModal';
import { routes } from '../../utils/routeNames';
import formattedMessage from '../../languageModule';
import style from './DesktopMenu.scss';
import { logoutUser } from '../../utils/utils';

const DesktopMenu = (props) => {
	const intl = useIntl();
	let navigate = useNavigate();

	useEffect(() => {
		props.setActiveRoute(props.path);
	}, [props.path]);

	const [logout, setLogout] = useState(false);

	const Logout = () => (
		<PortalModal
			className={style.container}
			title={formattedMessage.logout}
			subtitle={formattedMessage.titolo}
			hasOutcome
			outcome='warning'
			open={logout}
			buttons={[
				{
					variant: 'outlined',
					onClick: () => {
						setLogout(false);
					},
					contentText: formattedMessage.annulla,
				},
				{
					variant: 'contained',
					onClick: () => {
						logoutUser()
							.then(() => {
								window.sessionStorage.clear();
								window.location.replace('/');
							})
							.catch((error) => {
								console.error(error);
							});
					},
					contentText: formattedMessage.conferma,
				},
			]}
		/>
	);

	if (props.path.toLowerCase() === 'startenrollment') {
		return '';
	}

	return (
		<>
			<AppBar position='static' className={`${style.appBarDesktop} ${!props.logged ? style.loginPage : ''}`}>
				<Toolbar>
					<Grid className={style.logo}>
						{/* TODO: FIX DYNAMIC LOGO */}
						<img src={props.logged ? props.logoLight : props.logoDark} alt={`logo ${props.brand}`} />
					</Grid>
					{props.logged && !/user-enrollment/.test(window.location.pathname) ? (
						<Grid className={`${style.content} ${style.desktop}`}>
							<Grid className={style.menuList}>
								{routes
									.filter(({ routeName }) => props.permittedRoutes.includes(routeName))
									.map((element, index) => (
										<Grid
											key={`route-${index}`}
											className={`
											${style.menuItem}
											${props.activeRoute === element.route ? style.active : ''}
										`}>
											<ListItemText
												key={`route-item-${index}`}
												primary={intl.formatMessage(element.label)}
												onClick={() => {
													props.handleSetRoute(element.route, element.route);
												}}
											/>
											{element.subRoutes.length > 0 ? (
												<Grid key={`subroute-${index}`} className={style.menuDropdown}>
													{element.subRoutes.map((elem, index) => (
														<Typography
															key={`subroute-item-${index}`}
															variant='body1'
															className={style.subItem}
															onClick={() => {
																props.handleSetRoute(elem.route, element.route);
															}}>
															{intl.formatMessage(elem.label)}
														</Typography>
													))}
												</Grid>
											) : null}
										</Grid>
									))}
							</Grid>
							<Grid
								className={style.iconActions}
								onClick={() => {
									navigate('/account');
									props.setActiveRoute('account');
								}}>
								<i className={`nexi-icons-user ${props.activeRoute === 'account' ? style.active : ''}`} />
							</Grid>
							<Button
								className={style.logout}
								onClick={() => {
									setLogout(true);
								}}>
								<FormattedMessage {...formattedMessage.logout} />
							</Button>
						</Grid>
					) : null}
				</Toolbar>
			</AppBar>
			<Logout />
		</>
	);
};

DesktopMenu.propTypes = {
	// Add here some propTypes
	// and set a minimal description i.e.
	/** Description of prop "baz". */
	path: PropTypes.string,
	brand: PropTypes.string,
	logo: PropTypes.object,
	logged: PropTypes.bool.isRequired,
	handleSetRoute: PropTypes.func,
	logoLight: PropTypes.string,
	logoDark: PropTypes.string,
	activeRoute: PropTypes.string,
	setActiveRoute: PropTypes.func,
	permittedRoutes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

DesktopMenu.defaultProps = {
	// Add here some default propTypes values
	path: '/',
	brand: '',
	handleSetRoute: () => {},
	setActiveRoute: () => {},
	permittedRoutes: ['Home'],
};

export default DesktopMenu;
